import React, { memo, useCallback, useState } from 'react';

import './style.sass';

import { Dropdown } from '../common/Dropdown';
import { SelectItem } from '../common/SelectItem';
import { useBreakpointType } from 'app/services/breakpoints';
import { PremiumLevel } from 'common/types/models';
import { UserLevelTitles } from 'app/utils/userLevelHelpers';

type Props = {
    currentLevel: PremiumLevel,
    onSelectLevel: (newLevel: PremiumLevel) => void,
};

const premiumLevels = Object.values(PremiumLevel).filter(l => typeof l !== 'string') as PremiumLevel[];

export const UserLevelSelect = memo(({ currentLevel, onSelectLevel }: Props) => {
    const [isActiveDropdown, setIsActiveDropdown] = useState<boolean>(false);

    const { isMobile } = useBreakpointType();

    const onClickSelectItem = useCallback((newLevel: PremiumLevel) => {
        if (onSelectLevel) {
            onSelectLevel(newLevel);
        }

        setIsActiveDropdown(false);

    }, [onSelectLevel]);

    return (
        <Dropdown
            isActive={isActiveDropdown}
            setIsActive={setIsActiveDropdown}
            button={
                <span className="p1-medium dark-violet">{UserLevelTitles[currentLevel]}</span>
            }
            directionX={isMobile ? 'right' : 'left'}
        >
            <div className="campaign-status-list">
                {premiumLevels.map((level, index) => (
                    <SelectItem
                        key={`${index}_select-item_${level}`}
                        isActive={level === currentLevel}
                        onClickItem={() => onClickSelectItem(level)}
                        text={UserLevelTitles[level]}
                    />
                ))}
            </div>
        </Dropdown>
    );
});
